import React from 'react';

import Grid from '~/components/core/Atomic/Grid/Grid';
import SwitchFormik from '~/components/core/Formik/SwitchFormik';
import TextField from '~/components/core/Molecules/Fields/TextField';
import CliveObjectConfig from '~/components/SystemConfiguration/CliveConfiguration/CliveObjectConfig';

import BaseConfigurationSection from './BaseConfigurationSection';

const TITLE = 'External Claim Numbers';
const KEY = 'external_claim_numbers';
const SECTION_ID = `configuration.${KEY}`;

const ExternalClaimNumberConfigSection = () => {
  return (
    <BaseConfigurationSection title={TITLE} subtitle={`Key: ${KEY}`} isSection>
      <Grid item xs={6}>
        <TextField label="Display Name" value={TITLE} fullWidth disabled />
      </Grid>
      <Grid item xs={6}>
        <TextField value={KEY} label="Key" fullWidth disabled />
      </Grid>
      <Grid item xs={2}>
        <SwitchFormik id={`${SECTION_ID}.active`} label="Show" hideErrorGap />
      </Grid>
      <Grid item xs={10} /> {/* Spacer */}
      <CliveObjectConfig basePath={SECTION_ID} />
    </BaseConfigurationSection>
  );
};

export default ExternalClaimNumberConfigSection;
